import React, { useState, useEffect } from "react";
import theme from "../../../styles/theme";
import UserAvatar from "../Forms/UserAvatar";
import { PROJECT_ROLES } from "../../../base/constants";
import DropdownList from "../Forms/DropdownList";
import textFilter from "../Forms/TextFilter";
import { API_ROUTES } from "../../../config/api";
import{apiFetch} from "../../../config/apiFetch";

/**
 * Carte d’un membre de projet :
 *  - affiche nom, email, avatar, rôle
 *  - permet de modifier le rôle
 *  - permet de retirer le membre du projet
 */
const CardUser = ({
  fullName,
  email,
  role,
  userId,
  projectId,
  onRoleChange,
  onUserRemoved,
}) => {
  const roleKey =
    Object.keys(PROJECT_ROLES).find((k) => PROJECT_ROLES[k] === role) || "";
  const [selectedRole, setSelectedRole] = useState(roleKey);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const ROLE_COLORS = theme.statusColors?.projectRole || {};

  useEffect(() => {
    const key =
      Object.keys(PROJECT_ROLES).find((k) => PROJECT_ROLES[k] === role) || "";
    setSelectedRole(key);
  }, [role]);

  const handleRoleChange = (val) => {
    const key =
      typeof val === "string"
        ? PROJECT_ROLES[val]
          ? val
          : Object.keys(PROJECT_ROLES).find((k) => PROJECT_ROLES[k] === val)
        : val?.value;
    if (!key) return;
    setSelectedRole(key);
    onRoleChange?.(userId, key);
  };

  const handleRemoveUser = async () => {
    if (isProcessing) return;
    // if (!window.confirm(`Retirer ${fullName} du projet ?`)) return;
    try {
      setIsProcessing(true);
      const res = await apiFetch(API_ROUTES.projectUsers.remove(projectId, userId), {
        method: "DELETE",
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      onUserRemoved?.(userId);
    } catch (err) {
      console.error("Erreur suppression membre :", err);
      alert("Impossible de retirer ce membre du projet.");
    } finally {
      setIsProcessing(false);
    }
  };

  const isAdmin = PROJECT_ROLES[selectedRole] === PROJECT_ROLES.ADMIN;
  const iconSrc = isAdmin
    ? "/assets/icones/chield.svg"
    : "/assets/icones/user-minus.svg";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        border: `1px solid ${theme.colors.borders.default}`,
        borderRadius: theme.borders.radius.lg,
        padding: theme.spacing.md,
        marginBottom: theme.spacing.sm,
        backgroundColor: theme.colors.background.surface,
        boxShadow: theme.shadows.sm,
        transition: "all 0.2s ease",
        opacity: isProcessing ? 0.5 : 1,
        position: "relative",
        overflow: "visible",
        zIndex: isDropdownOpen ? 1000 : 1,
        height: "64px", // ✅ fixe une hauteur uniforme à la carte
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.boxShadow = theme.shadows.md;
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.boxShadow = theme.shadows.sm;
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {/* Bloc gauche : avatar + infos */}
      <div style={{ display: "flex", alignItems: "center", gap: theme.spacing.md }}>
        <UserAvatar name={fullName} size={38} />
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span
            style={{
              fontSize: theme.fontSizes.sm,
              color: theme.colors.text.default,
              fontWeight: theme.fontWeights.medium,
            }}
          >
            {fullName}
          </span>
          <span
            style={{
              fontSize: theme.fontSizes.xs,
              color: theme.colors.text.body,
            }}
          >
            {email}
          </span>
        </div>
      </div>

      {/* Bloc droit : dropdown + icône */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: theme.spacing.lg,
          position: "relative",
          height: "100%",
        }}
      >
        {/* Conteneur parfaitement centré */}
        <div
          style={{
            display: "flex",
            alignItems: "center", // ✅ centre verticalement le dropdown
            height: "100%",
          }}
        >
          <DropdownList
            label=""
            value={PROJECT_ROLES[selectedRole]}
            onChange={(val) => handleRoleChange(val)}
            options={Object.entries(PROJECT_ROLES).map(([key, label]) => ({
              value: label,
              label,
            }))}
            placeholder="Rôle"
            onOpen={() => setIsDropdownOpen(true)}
            onClose={() => setIsDropdownOpen(false)}
            colorCategory="projectRole" // ← c’est ce qui lie à ton thème corrigé
            style={{
              width: "140px",
              fontSize: theme.form.field.fontSize,
              marginBottom: 0,
              marginLeft: 0,
              zIndex: 9999,
              alignSelf: "center",
              paddingTop: 20,   // ✅ ajuste vers le haut (diminue si trop bas)
              paddingBottom: 0 // ✅ ajuste vers le bas (augmente si trop haut)

            }}
          />

        </div>
        <img
          src={iconSrc}
          alt={isAdmin ? "Administrator" : "Supprimer"}
          onClick={!isAdmin ? handleRemoveUser : undefined}
          style={{
            width: 18,
            height: 18,
            cursor: isAdmin ? "default" : "pointer",
            opacity: isAdmin ? 0.4 : 1,
            alignSelf: "center", // ✅ icône aussi centrée
          }}
        />
      </div>
    </div>
  );
};

export default CardUser;
